import { useQuery } from '@tanstack/react-query';
import { branchQueries, GetBranchesParams } from '../../../../packages/api/src/queryStore/shared/branch';

interface UseGetBranchesOptions {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
  staleTime?: number;
  cacheTime?: number;
}

export const useGetBranches = (
  params: GetBranchesParams, 
  options?: UseGetBranchesOptions
) => {
  return useQuery({
    ...branchQueries.queries.getBranches({...params}),
    select: (data: any) => ({
      total: data?.total || 0,
      branches: data?.data?.map((branch: any) => ({
        ...branch,
        city: branch.address?.city?.name,
        area: branch.address?.area?.name,
        city_id: branch.address?.city?.id,
        area_id: branch.address?.area?.id,
        contact_person_mobile:
        {
          mobile:branch.contact_person_mobile?.length<5?
          '':branch.contact_person_mobile,
          email:branch?.contact_person_email
        } ,
        actions: {
          id: branch.id,
          name: branch.name,
        },
      })) || [],
    }),
    enabled: options?.enabled ?? true,
  });
};